import { Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/components/DynamicText";
import { DynamicHtml } from "@/components/DynamicHtml";

export default function Intro({ className, url_slug, title, image }) {
  return (
    <div className={clsx(className, classes.intro)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <Row>
          <Col xs={12} md={6}>
            <div className="d-flex flex-column justify-content-center h-100">
              <DynamicText path={`page.case.study.${url_slug}.intro.title`} tag="h2" className="mb-5">
                Partnering With North West Anglia NHS Foundation Trust
              </DynamicText>
              <DynamicHtml path={`page.case.study.${url_slug}.intro.text`}>
                <p>
                  <strong>
                    Is your Trust looking to simplify their IT systems? Has system training been factored into the
                    project scope?
                  </strong>
                </p>
                <p>Here’s how we helped one Trust lead its PAS implementation project with a people-first approach.</p>
              </DynamicHtml>
            </div>
          </Col>
          <Col xs={12} md={6} className="position-relative">
            <figure className="mx-xl-6 mb-0">
              <img className="w-100" src={image} alt={title} />
            </figure>
            <div className={classes.intro__tags}>
              <div>
                <div className="bg-grey">
                  <DynamicText path={`page.case.study.${url_slug}.intro.tag.systems`}>1 System</DynamicText>
                </div>
              </div>
              <div>
                <div className="bg-blue text-white">
                  <DynamicText path={`page.case.study.${url_slug}.intro.tag.sites`}>3 Sites</DynamicText>
                </div>
              </div>
              <div>
                <div className="bg-blue-dark text-white">
                  <DynamicText path={`page.case.study.${url_slug}.intro.tag.staff`}>7000 Staff</DynamicText>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
